import React from 'react'

export default function Br(props) {
    let margin = props.margin || 25
    return (
        <div style={{ marginTop: margin }}>

        </div>
    )
}
